import React from "react";

import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import CancelIcon from "@material-ui/icons/Cancel";
import { Trad } from "src/components";
import {_Button, _ButtonAPI, _Dialog} from "..";

interface IActionDialogProps {
    Open: boolean;
    Title: string;
    Message: string;
    OnCancel: () => void;
    OnConfirm: () => void;
    OnClose: () => void;
}

export const _ActionDialog: React.FC<IActionDialogProps> = ({ Open, Title , Message, OnCancel, OnConfirm, OnClose }) => {
    
    return (
        <>
            <_Dialog
                Open={Open}
                Title={Trad.Trad(Title)}
                Type="warning"
                Actions={
                    <>
                        <_Button
                            Icona={<CancelIcon />}
                            Testo={"Cancella"}
                            OnClick={() => OnCancel()}
                        />
                        <_Button
                            Icona={<ThumbUpAltIcon />} 
                            Testo={"Ok"} 
                            OnClick={() => OnConfirm()}
                        />
                    </>
                }
                OnClose={OnClose}
            >
                {Trad.Trad(Message)}
            </_Dialog>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/ActionDialog.tsx